<template>
  <v-text-field
    data-test-id="primaryTextFieldInput"
    v-bind="$attrs"
    style="margin-top: 0.5rem"
    v-model="model"
    v-if="mode === EditorMode.Edit"
    color="primary"
    density="comfortable"
    variant="underlined"
  >
    <template v-slot:label>
      <span>{{ label }}&nbsp;<span v-if="required" class="required-text">*</span></span>
    </template>
    <!-- @vue-skip -->
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData"
      ><slot :name="name" v-bind="slotData"
    /></template>
  </v-text-field>
  <DisplayText v-else data-test-id="primaryTextFieldInputDisplay" :value="model" :label="label" />
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { EditorMode } from '@/enums/EditorMode'
import type { PropType } from 'vue'

// PROPS & EMITS
defineProps({
  required: { type: Boolean, default: false },
  label: { type: String, default: '' },
  mode: { type: String as PropType<EditorMode>, default: EditorMode.Edit }
})

// REACTIVE VARIABLES
const model = defineModel()

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
</script>
